import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  stream: {},
  alumniStreamRecommendations: [],
  advisorStreamRecommendations: []
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/stream/vuex/index.js